
  import { defineComponent, ref, computed, watch } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    name: 'ive-filter',
    emit: ['ive-type-selected', 'reset'],
    components: {
      Multiselect,
    },
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref<any>({
        areaId: '',
        price: '',
      });

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('ive-type-selected', selectedItems);
      };
      const onReset = () => {
        selectedItems.value = {
          areaId: '',
          price: '',
        };
        emit('reset', selectedItems.value);
      };

      await store.dispatch(Actions.GET_ALL_IVE_AREAS);

      reinitializeComponents();

      return {
        areas: computed(() => store.getters.allIveAreasList),
        onSubmit,
        onReset,
        translate,
        selectedItems,
      };
    },
  });
